<div class="modal-header confirm-modal-component">
    <div class="icon-title">
        <fa-icon
            class="icon-left"
            [ngClass]="{'fa-icon-color--warning': modalIntentType === 'warning', 'fa-icon-color--danger': modalIntentType === 'danger' }"
            [icon]="['fas',modalIntentType === 'warning' ? 'exclamation-circle' : 'exclamation-triangle']"
            *ngIf="modalIntentType"
        >
        </fa-icon>
        <h2 class="modal-title" id="modal-title">{{ HeaderText | translate }}</h2>
    </div>
    <button class="cdx-button cdx-button--icon" aria-describedby="modal-title" (click)="modalClose()">
        <fa-icon class="fa-fw cdx-button__icon" [icon]="['fas','times']"></fa-icon>
    </button>
</div>
<div class="modal-body">
    <p><strong>{{ QuestionText | translate }}</strong></p>
    <p>{{ MessageText | translate }}</p>
</div>
<div class="modal-footer">
    <button class="cdx-button cdx-button--secondary cdx-button--outline" (click)="modalClose()">
        <span class="cdx-button__text">{{ ButtonCancelText | translate | uppercase }}</span>
    </button>
    <button class="cdx-button cdx-button--primary cdx-button--danger ml-2" *ngIf="!IsApprovalConfirm" (click)="modalConfirm()">
        <span class="cdx-button__text">{{ ButtonConfirmText | translate | uppercase}}</span>
    </button>
    <button class="cdx-button cdx-button--primary" *ngIf="IsApprovalConfirm" (click)="modalConfirm()">
        <span class="cdx-button__text">{{ ButtonConfirmText | translate | uppercase }}</span>
    </button>
</div>